<div style="display: flex; align-items: center;">
  <div class="thumbs" (click)="thumbsUp()" [ngClass]="{ 'positive-rating': message.rating===1 }">
    <span class="material-icons-outlined mi-thumbs-up ">thumb_up</span>
    <div class="burst" *ngIf="message.rating===1">
      <div class="debris"></div>
      <div class="debris"></div>
      <div class="debris"></div>
      <div class="debris"></div>
      <div class="debris"></div>
      <div class="debris"></div>
      <div class="debris"></div>
      <div class="debris"></div>
      <div class="debris"></div>
    </div>
  </div>
  <div class="thumbs" (click)="thumbsDown()" [ngClass]="{ 'negative-rating': message.rating===-1 }">
    <div class="burst" *ngIf="message.rating===-1">
      <div class="debris"></div>
      <div class="debris"></div>
      <div class="debris"></div>
      <div class="debris"></div>
      <div class="debris"></div>
      <div class="debris"></div>
      <div class="debris"></div>
      <div class="debris"></div>
      <div class="debris"></div>
    </div>
    <span class="material-icons-outlined mi-thumbs-down">thumb_down</span>
  </div>
</div>